import React from 'react';
import PropTypes from 'prop-types';
import Error from './Error/index.jsx';
import styles from './style.module.scss';

const Errors = props =>
	<ul className={styles.container}>
		<Error error={props.errors}/>
	</ul>

Errors.propTypes = {
	errors: PropTypes.object.isRequired,
}

export default Errors;